const extractAddress = (inputData, addressType) => {
	//* If the address is from the Autocomplete
	//* we also need to pass the address ID
	//* if it was manually added, we need to extract
	//* the postcode, state and suburb from the '...AddressPostcode'
	const response = {};
	const address = inputData[`${addressType}Full`];
	const addressPostcode = inputData[`${addressType}PostcodeSuburb`];

	if (address != null || address?.length > 0) {
		response.fullAddress = inputData[`${addressType}Full`];
		response.guid = inputData[`${addressType}FullGuid`];
	}

	if (addressPostcode != null || addressPostcode?.length > 0) {
		const parts =
			inputData[`${addressType}PostcodeSuburb`]?.fullPostcode?.split(" ");
		const postcode = parts?.shift();
		const state = parts?.pop();
		const suburb = parts?.join(" ");

		response.unitNumber = inputData[`${addressType}UnitNumber`] || "";
		response.levelNumber = inputData[`${addressType}LevelNumber`] || "";
		response.streetNumber = inputData[`${addressType}StreetNumber`];
		response.streetNumberType = inputData[`${addressType}StreetNumberType`];
		response.streetName = inputData[`${addressType}StreetName`];
		response.streetType = inputData[`${addressType}StreetNameType`];
		response.suburb = suburb;
		response.state = state;
		response.postcode = postcode;
	}
	return response;
};

export const updateContactDetailsMapping = async (inputData) => {
	const response = {
		basicDetails: {
			postalAddress: extractAddress(inputData, "policyMailingAddress"),
			residentialAddressSameAs:
				inputData?.bothAddressesTheSame === "yes" ? true : false,
			...(inputData?.bothAddressesTheSame === "no" && {
				residentialAddress: extractAddress(inputData, "residentialAddress"),
			}),
			telephone: {
				mobile: inputData?.personOne?.contactNumber,
			},
			email: inputData?.personOne?.emailAddress,
			policyDocumentRequestType:
				inputData?.policyDocumentRequestType === "yes" ? "E" : "P",
		},
	};

	return response;
};

export default updateContactDetailsMapping;
